export const isServiceWorkerAvailable = () =>
  'serviceWorker' in navigator && 'PushManager' in window;
